<template>
    <div class="container-fluid gallery">
        <div class="row justify-content-center">
            <div class="col-md-12 mx-0">
                <ul class="d-flex breadcrumb-list">
                    <li class="breadcrumb-item"><a href="/" class="text-decoration-none">{{ breadCrumbs.home }}</a></li>
<!--                    <li class="breadcrumb-item active">{{ breadCrumbs.gallery }}</li>-->
                    <li class="breadcrumb-item active">{{ breadCrumbs.models}}</li>
                </ul>
                <TheLoaderComponent v-if="showLoader"></TheLoaderComponent>

<!--                <div class="d-flex justify-content-between">-->
<!--                    <h1 class="header-title">{{ galleryTitle }}</h1>-->
<!--                    <div class="mb-4 col-2 search__block">-->
<!--                        <input type="text" v-model="valueSearch" class="search__input" @input="searchModel()"-->
<!--                               name="name"/>-->
<!--                        <p v-if="nothingFound === true">Nothing was found for your request</p>-->
<!--                    </div>-->

<!--                </div>-->

                <div class="d-flex">
<!--                    <div class="categories d-none d-lg-block">-->
<!--                        <ul>-->
<!--                            <li class="background-hover-category active js-all-category">-->
<!--                                <a href="/gallery" class="text-decoration-none">-->
<!--                                    <p>-->
<!--                                        {{ titles.allCategory }}-->
<!--                                    </p>-->
<!--                                </a>-->
<!--                            </li>-->

<!--                            <li class="background-hover-category" v-for="category in categories">-->
<!--                                <a :href="category.slug" @click="categoryFilter($event)" class="text-decoration-none">-->
<!--                                    <p>{{ lang === 'ar-sa' ? category.title['ar-sa'] : category.title['en'] }}</p>-->
<!--                                </a>-->
<!--                            </li>-->
<!--                        </ul>-->
<!--                    </div>-->

                    <div class="col mt-4 pt-2 mt-md-0 pt-md-0">
<!--                        <div class="category-dropdown dropdown">-->
<!--                            <a class="dropdown-toggle d-flex align-items-center text-decoration-none  js-dropdown js-category-dropdown navigation-footer"-->
<!--                               href="#" role="button"-->
<!--                               data-bs-toggle="dropdown"-->
<!--                               aria-expanded="false">-->
<!--                                <p>Category name</p>-->
<!--                            </a>-->

<!--                            <ul class="dropdown-menu dropdown-category-menu">-->
<!--                                <li class="background-hover-category active js-all-category">-->
<!--                                    <a href="/gallery" class="text-decoration-none">-->
<!--                                        <p>-->
<!--                                            {{ titles.allCategory }}-->
<!--                                        </p>-->
<!--                                    </a>-->
<!--                                </li>-->
<!--                                <li class="background-hover-category" v-for="category in categories">-->
<!--                                    <a :href="category.slug" @click="categoryFilter($event)"-->
<!--                                       class="text-decoration-none">-->
<!--                                        <p>{{ lang === 'ar-sa' ? category.title['ar-sa'] : category.title['en'] }}</p>-->
<!--                                    </a>-->
<!--                                </li>-->
<!--                            </ul>-->
<!--                        </div>-->

<!--                        <div class="tags d-flex d-none js-tags-filter-gallery tags-filter-gallery"></div>-->

                        <div class="gallery-models-block">
                            <div v-if="this.products.length">
                                <UsersModelComponent
                                    :size="'small'"
                                    :place="'gallery'"
                                    :products="this.products"
                                    :default-models-color="this.defaultModelsColor"
                                />
                            </div>
                            <h2 class="empty__block text-center" v-else>{{ titles.notModel }}</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="application/javascript">
import UsersModelComponent from "./UsersModelComponent";
import TheLoaderComponent from "./TheLoaderComponent";

export default {
    components: {
        UsersModelComponent,
        TheLoaderComponent
    },
    data() {
        return {
            nothingFound: false,
            valueSearch: '',
            showLoader: false,
            products: [],
            categories: [],
            increment: 0,
            breadCrumbs: {
                home: '',
                gallery: ''
            },
            galleryTitle: '',
            lang: window.currentLang,
            titles: {
                allCategory: '',
                notModel: ''
            },
            copyProducts: [],
            searchTimeout: null,
        }
    },

    mounted() {
        let vm = this
        let togglemodal = JSON.parse(localStorage.getItem('open'))

        if (togglemodal) {
            localStorage.setItem('open', JSON.stringify(false));
        }
        // vm.categories = categories

        window.addEventListener('scroll', function () {
            if (window.scrollY + window.innerHeight >= document.body.scrollHeight - 50) {
                vm.loadMore()
            }
        })

        vm.loadMore()
    },
    updated() {
        this.changeContent()
    },
    methods: {
        searchModel() {
            let vm = this
            clearTimeout(vm.searchTimeout);
            vm.searchTimeout = setTimeout(() => {
                vm.nothingFound = false
                vm.showLoader = true
                if (vm.valueSearch.length > 0) {
                    axios.post('/gallery/search', {search: this.valueSearch}).then(function (response) {
                        vm.showLoader = false

                        if (response.data.data.length > 0) {
                            vm.copyProducts = vm.products

                            vm.products = response.data.data
                        } else {
                            vm.nothingFound = true
                        }
                    }).catch(function (error) {
                        vm.showLoader = false

                    })
                } else if (vm.valueSearch.trim().length === 0) {
                    vm.showLoader = false

                    vm.products = vm.copyProducts
                }

                return vm.products
            }, 450);
        },
        changeContent() {
            if (window.currentLang === 'ar-sa') {
                this.lang = 'ar-sa'
                this.breadCrumbs.home = 'الرئيسية'
                this.breadCrumbs.models = 'معرض النماذج والمنتجات'
                this.breadCrumbs.gallery = 'معرض النماذج والمنتجات'
                this.galleryTitle = 'معرض النماذج والمنتجات'
                this.titles.allCategory = 'جميع الفئات'
                this.titles.notModel = 'لا توجد منتجات في هذه الفئة'
            } else {
                this.titles.notModel = 'There are no models in this category'
                this.titles.allCategory = 'All categories'

                this.lang = 'en'

                this.breadCrumbs.home = 'Home'
                this.breadCrumbs.models = 'Users Models'
                this.breadCrumbs.gallery = 'Gallery'
                this.galleryTitle = 'Gallery'

            }
        },

        loadMore() {
            let vm = this
            vm.increment++
            axios.get(`/users-models/data?page=${parseInt(this.increment)}`).then(function (response) {
                let responseData=response.data.models;
                responseData.forEach(item => {
                    item.color = response.data.defaultModelsColor;
                    item.img = '/storage/models_static_gif/' + item.file_hash + '_' + item.file_size + '_' + item.color.replace('#', '') + '.gif';
                    item.dynamic_img = '/storage/models_dynamic_mp4/' + item.file_hash + '_' + item.file_size + '_' + item.color.replace('#', '') + '.mp4';
                    item.dynamic_img_ready = false;
                    item.mouseover = false;
                    item.hover = false;
                });
                vm.products = vm.products.concat(responseData);
            })
        },
        categoryFilter(event) {
            let removeClass = document.querySelectorAll('.background-hover-category')
            let allCategoryBtn = document.querySelector('.js-all-category')
            allCategoryBtn.classList.remove('active')
            let emptyBlock = document.querySelector('.empty__block')

            event.preventDefault()
            removeClass.forEach(item => {
                item.classList.remove('active')
            })
            event.currentTarget.closest('li').classList.add('active')

            let vm = this
            let url = event.currentTarget.getAttribute('href')
            vm.showLoader = true

            axios.get(`/gallery/category/${url}`).then(function (response) {
                response.data.data == 0 ? emptyBlock.classList.remove('d-none') : emptyBlock.classList.add('d-none')

                vm.showLoader = false
                vm.products = response.data.data
            })
        },

    }
}
</script>

<style lang="scss">
@import "../../sass/front/gallery";
@import "../../sass/front/user-model";
</style>
